import React from "react";
import BaseFunctions from "../../components/base/baseFunctions";
export default BaseFunctions;